export default __webpack_public_path__ + "static/media/plsLogoBW.06b072f9.svg";